import { Modal } from 'bootstrap';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import uuid from 'react-uuid';
import TapIcon from '../../services/TapIcon';
import moment from 'moment';
import InputWorkstationSearch from '../includes/ui/InputWorkstationSearch';
import InputAssetSearch from '../includes/ui/InputAssetSearch';
import TapSelect from '../../components/ui/TapSelect';
import { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import HttpAPICall from '../../services/HttpAPICall';
import Loader from '../../components/ui/Loader/Loader';


function AssetConfigurationFilterModal({submitModalData, searchedFilterData}, ref) {
    const modalId                   =   uuid();
    const modalElementRef           =   useRef();
    const modalRef                  =   useRef();
    const accessToken               =   useSelector(state => state.auth.access_token);
    const iamUserSite               =   useSelector(state => state.app.user_sites);
    const iam_asset_types           =   useSelector(state => state.app.asset_type);
    const setting                   =    useSelector(state => state.app.setting);

    const configUrl                 =   IAM_API_BASE_URL_2 + '/asset_productivity_config';    

    const initialFilter             =   {
        search_like_name                :   '',
        search_status                   :   '',
        search_attachment_ids           :   [],
        search_asset_type_ids           :   [],
        search_workstation_ids          :   [],
        search_asset_ids                :   [],
        search_site_ids                 :   [],
        search_activity_ids             :   [],
        search_units                    :   [],
        date_range                      :   ''//moment(new Date()).format("YYYY-MM-DD"),
    }

    const filterFormLabel           =   {
        search_like_name                :   'Config Name : ',
        search_status                   :   'Status : ',
        search_attachment_ids           :   `${setting?.attachment_name}  : `,
        search_asset_type_ids           :   'Asset Types : ',
        search_workstation_ids          :   'Workstations : ',
        search_asset_ids                :   'Assets : ',
        search_site_ids                 :   'Sites : ',
        search_activity_ids             :   'Activities : ',
        search_units                    :   'Units : ',
        date_range                      :   'Date : ',
    }


    const [formSubmitting, setFormSubmitting]       =   useState(false);
    const [loading, setLoading]                     =   useState(false);
    const [filterData, setFilterData]               =   useState(initialFilter);
    const [formData, setFormData]                   =   useState({
        attachments         :   [],
        iamAssetTypes       :   [],
        sites               :   [],
        activities          :   [],
        units               :   [],
        status              :   [],
        workstations        :   [],
    });

    useImperativeHandle(ref, () => ({                                   
        initModalHandler: () => {   
            if(formData.attachments.length === 0 || formData.iamAssetTypes.length === 0 || formData.sites.length === 0 || formData.activities.length === 0 || formData.units.length === 0 || formData.status.length === 0 || formData.workstations.length === 0) {
                formDataApi();
            }
            openModal();
        }
    }));

    useEffect(() => {
        modalElementRef.current             =   document.getElementById(modalId);
        modalRef.current                    =   new Modal(modalElementRef.current, {keyboard: false, backdrop :false});
        return () => {
            if (modalRef.current) {
                modalRef.current.dispose();
            }
        };
    }, []);
        
    const openModal                 =   () => {
        searchedFilterData && setFilterData(pre => ({...pre, ...searchedFilterData}));
        if (modalRef.current) {
            modalRef.current.show();
        }
    }
    const closeModal                =   () => {
        if (modalRef.current) {
            setFilterData(initialFilter);
            modalRef.current.hide();
        }
    }
    const formDataApi               =   ()  =>  {
        setLoading(pre => !pre);
        HttpAPICall.withAthorization('GET', configUrl + '/form_data', accessToken, {}, {}, (res) => {
            const resp          =   res.data;
            setFormData(pre => ({
                ...pre,
                status          :   resp.status.map(s => ({label : s.status, value: s.key})),
                attachments     :   resp.attachments.map(s => ({label : s.name, value: s.id})),
                units           :   resp.uom.map(s => ({label : s.measuring_unit, value: s.id})),
                activities      :   resp.activity_data.map(s => ({label : s.activity_name, value: s.id})),
                workstations    :   resp.workstations.map(s => ({label : s.workstation_name, value: s.id})),
                sites           :   iamUserSite.map(s => ({label : s.site_name, value: s.id})),
                iamAssetTypes   :   iam_asset_types ? iam_asset_types.map((at) => { return {value: at.id, label: at.asset_type_name}}) : [],
            }))

        }).then(() => setLoading(pre => !pre));

    }

    const handleMultipleSelect       =   (selectedOption, fieldName) => {
        setFilterData(pre => ({
            ...pre,
            [fieldName] : selectedOption ? selectedOption.map(s => s.value) : []
        }))
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let serachFormKeys                  =   Object.keys(filterData);
        let searchedElems                   =   [];
        let itemSearchParams                =   {};
        serachFormKeys.map((key)        =>  {
            let label                       =   filterFormLabel[key];
            let value                       =   filterData[key];
            if(value && value.toString().length > 0) {
                itemSearchParams[key]      =   value;
                if(label) {
                    let show_val            =   value;

                    if(key == 'search_like_name') {
                        show_val            =   filterData.search_like_name;
                    }
                    // search_asset_ids        
                    if(key == 'search_asset_type_ids') {
                        show_val            =   formData.iamAssetTypes.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_site_ids') {
                        show_val            =   formData.sites.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_activity_ids') {
                        show_val            =   formData.activities.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }     
                    if(key == 'search_units') {
                        show_val            =   formData.units.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_workstation_ids') {
                        show_val            =   formData.workstations.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_attachment_ids') {
                        show_val            =   formData.attachments.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if(key == 'search_status') {
                        show_val            =   formData.status.find((s) => value === s.value)?.label;
                    }
                    
                    // if(key == 'date_range') {
                    //     let  start_range        =      moment(formData.reportFilterForm.date_range_start).format('DD-MMM-YYYY');
                    //     let end_range           =      moment(formData.reportFilterForm.date_range_end).format('DD-MMM-YYYY');
                    //     let display_custom      =      `Custom Date Range (${start_range} - ${end_range})`;
                    //     show_val                =     formData.allPeriods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                    // }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        submitModalData(searchedElems, filterData);
        closeModal();
    }

    
    return (
      <div
        className="modal fade"
        id={modalId}
        ref={modalElementRef}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Search Asset Configuration</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                disabled={formSubmitting}
                onClick={closeModal}
                aria-label="Close"
              ></button>
            </div>
            {/* <div className="row mb-3">
                <label className="col-sm-3 col-form-label text-end">Asset</label>
                <div className="col-sm-6">
                    <InputAssetSearch
                        // changeEvent={(selectedOption) => {}
                        placeholder="Search Asset"
                        isMulti={true}
                        containerHeight="30px"
                        fontSize="93%"
                        // value={formData.searchedAssets.length > 0 ? formData.searchedAssets.map(a => { a.label = a.display_label; return a; }) : []}
                    />
                </div>
            </div> */}
            <div className="modal-body">
            <form className="bg-white p-3" onSubmit={handleSubmit} id={modalId + "filter"}>
                {
                    loading 
                    ?
                    <Loader/>
                    :
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label mb-3">Config Name</label>
                        <div className="col-sm-4 align-items-center mb-3">
                            <input
                                name="search_like_name"
                                type="text"
                                onChange={(e) => setFilterData(pre => ({...pre, search_like_name : e.target.value}))}
                                value={filterData.search_like_name}
                                placeholder='Config Name'
                                className="form-control"
                                id=""
                            />
                        </div>
                        <label className="col-sm-2 col-form-label mb-3">Site</label>
                        <div className="col-sm-4 align-items-center mb-3">
                            <TapSelect
                                options={formData.sites}
                                changeEvent={(selectedOption) => handleMultipleSelect(selectedOption, 'search_site_ids')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={formData.sites.filter(s => filterData.search_site_ids.includes(s.value))}
                                placeholder="Select Site"
                            />
                        </div>
                        <label className="col-sm-2 col-form-label mb-3">Asset Type</label>
                        <div className="col-sm-4 mb-3">
                            <TapSelect
                                options={formData.iamAssetTypes}
                                changeEvent={(selectedOption) => handleMultipleSelect(selectedOption, 'search_asset_type_ids')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                placeholder="All Asset Types"
                                value={formData.iamAssetTypes.filter(r =>  filterData.search_asset_type_ids.includes(r.value))}
                            />
                        </div>
                        <label className="col-sm-2 col-form-label mb-3">{setting?.attachment_name ? setting?.attachment_name : 'Attachment'}</label>
                        <div className="col-sm-4 mb-3">
                            <TapSelect
                                options={formData.attachments}
                                changeEvent={(selectedOption) => handleMultipleSelect(selectedOption, 'search_attachment_ids')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={formData.attachments.filter(s => filterData.search_attachment_ids.includes(s.value))}
                                placeholder={`Select ${setting?.attachment_name ? setting?.attachment_name : 'Attachment'}`}
                            />
                        </div>
                    {/* <div className="row mb-3">
                        <label className="col-sm-3 col-form-label text-end">Workstation</label>
                        <div className="col-sm-6">
                            <InputWorkstationSearch
                                placeholder="Search Workstation"
                                // changeEvent={(selectedOption) => {}}
                                menuPlacement="top"
                                isMulti={true}
                                // value={searchedWorkstation.length > 0 ? searchedWorkstation.map(w => w) : []}
                                containerHeight="30px"
                                fontSize="93%"
                            />
                        </div>
                    </div> */}
                        <label className="col-sm-2 col-form-label col-form-label-sm mb-3">Activity Name</label>
                        <div className="col-sm-4 mb-3">
                            <TapSelect
                                options={formData.activities}
                                changeEvent={(selectedOption) => handleMultipleSelect(selectedOption, 'search_activity_ids')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={formData.activities.filter(s => filterData.search_activity_ids.includes(s.value))}
                                placeholder="Select Activity"
                            />
                        </div>
                        <label className="col-sm-2 col-form-label col-form-label-sm mb-3">UOM</label>
                        <div className="col-sm-4 mb-3">
                            <TapSelect
                                options={formData.units}
                                changeEvent={(selectedOption) => handleMultipleSelect(selectedOption, 'search_units')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={formData.units.filter(s => filterData.search_units.includes(s.value))}
                                placeholder="Unit of Measurement"
                            />
                        </div>
                        <label className="col-sm-2 col-form-label col-form-label-sm mb-3">Workstation</label>
                        <div className="col-sm-4 mb-3">
                            <TapSelect
                                options={formData.workstations}
                                changeEvent={(selectedOption) => handleMultipleSelect(selectedOption, 'search_workstation_ids')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={formData.workstations.filter(s => filterData.search_workstation_ids.includes(s.value))}
                                placeholder="Workstations"
                            />
                        </div>
                        <label className="col-sm-2 col-form-label col-form-label-sm mb-3">Status</label>
                        <div className="col-sm-4 mb-3">
                            <TapSelect
                                options={formData.status}
                                changeEvent={(selectedOption) => {
                                    setFilterData(pre => ({...pre, search_status : selectedOption ? selectedOption.value : ''}))
                                }}
                                isSearchable={true}
                                isClearable={true}
                                value={formData.status.find(s => filterData.search_status === s.value)}
                                placeholder="Select Status"
                            />
                        </div>
                    </div>
                }
            </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                disabled={formSubmitting}
                data-bs-dismiss="modal"
                onClick={closeModal}
              >
                Close
              </button>
              <button
                type="submit"
                form={modalId + "filter"}
                disabled={loading}
                className="btn btn-primary"
              >
                Submit{" "}
                {formSubmitting && (
                  <TapIcon.FontAwesomeIcon
                    icon={TapIcon.faSyncAlt}
                    className="fa-spin"
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
}

export default forwardRef(AssetConfigurationFilterModal);